export const ScratchObject = function({w,h,src,text,detail,type}) {
    var self = this;  
    
    self.canvas = document.createElement('canvas');
    self.ctx = this.canvas.getContext('2d');
    self.canvas.width = w;
    self.canvas.height = h;
    self.maskItems = [];
    self.displayRate = 0;
    self.isConmplete = false;
    
    self.clear = function(ctx) {
      ctx.clearRect(0,0,this.w,this.y);
    }
    self.drawBase = function(ctx) {
      ctx.save();
      ctx.beginPath();
      ctx.globalCompositeOperation = 'source-in';
      ctx.fill();

      ctx.globalCompositeOperation = 'source-atop';
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, 244, 157);

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#333333';

      if (type == 'image') {
          ctx.font = 'bold 18px/1 Noto Sans KR';
          ctx.fillText(detail, w/2,138);

          const image = new Image();
          image.crossOrigin = 'Anonymous';
          image.src = src;
          drawImageProp(ctx, image, 123, 0.5, 160, 106);
      } else {
          ctx.font = '16px/1 Noto Sans KR';
          ctx.fillStyle = '#333'
          ctx.fillText(detail, w/2,108);
            console.log('여기', text, detail)
          ctx.font = 'bold 26px/1 Noto Sans KR';
          if (type == 'void') ctx.fillStyle = '#dc3e32';
          ctx.fillText(fittingString(ctx, text, 160), 123, 59);
      }

      ctx.restore();
    }
    self.drawMask = function(ctx) {
      for (var i = 0; i < this.maskItems.length; i++) {
        self.maskItems[i].draw(ctx);
      }
    }
    self.draw = function(ctx) {
      self.drawMask(ctx);
      self.drawBase(ctx);
    }
    self.append = function (id) {
      var container = document.getElementById(id);
      container.appendChild(self.canvas);
    };
  }
  ScratchObject.prototype.addMask = function (obj) {
    this.maskItems.push(obj);
  };
  ScratchObject.prototype.getDisplayRate = function () {
    var imgData = this.ctx.getImageData(0,0,this.canvas.width, this.canvas.height);
    console.log(imgData);
      imgData.crossOrigin = 'Anonymous'
    var w = imgData.width;
    var h = imgData.height;
    var data = imgData.data;
    var total = w * h;
    var visibles = 0;

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var p = (y * w + x) * 4;
        var alpha = data[p + 3];
        if (alpha < 200) visibles++;
      }
    }
    return 100 - 100 / total * visibles;
  };


  export const Mask = function(x,y,r) {
    this.x = x;
    this.y = y;
    this.r = r;
  }
  Mask.prototype.draw = function (ctx) {
    ctx.beginPath();
    ctx.fillStyle = '#000000';
    ctx.globalCompositeOperation = 'destination-over';
    ctx.arc(this.x,this.y,this.r,Math.PI*2,false);
    ctx.fill();
  };
  
  function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

      if (arguments.length === 2) {
          x = y = 0;
          w = ctx.canvas.width;
          h = ctx.canvas.height;
      }

      // default offset is center
      offsetX = typeof offsetX === "number" ? offsetX : 0.5;
      offsetY = typeof offsetY === "number" ? offsetY : 0.5;

      // keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      var iw = img.width,
          ih = img.height,
          r = Math.min(w / iw, h / ih),
          nw = iw * r,   // new prop. width
          nh = ih * r,   // new prop. height
          cx, cy, cw, ch, ar = 1;

      // decide which gap to fill
      if (nw < w) ar = w / nw;
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
      nw *= ar;
      nh *= ar;

      // calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      // 고정
      x = 42;
      y = 16;

      // make sure source rectangle is valid
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;
      // fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
  }
function fittingString(c, str, maxWidth) {
    var width = c.measureText(str).width;
    var ellipsis = '…';
    var ellipsisWidth = c.measureText(ellipsis).width;
    if (width<=maxWidth || width<=ellipsisWidth) {
        return str;
    } else {
        var len = str.length;
        while (width>=maxWidth-ellipsisWidth && len-->0) {
            str = str.substring(0, len);
            width = c.measureText(str).width;
        }
        return str+ellipsis;
    }
}